import Vue from 'vue';
import Component from 'vue-class-component';
import { User } from '~/utils';
import { Profile } from 'oidc-client';
import { ExtendedUserPermissions } from "~/utils/interfaces"
import { Data } from '~/utils';
import { Application } from '~/models/services/app';

const QUERY_HUB_USE_CASE_IDS: Record<string, number> = { prd: 106, uat: 105, dev: 218, development: 218 };

@Component({})
export default class NavbarUserActionsComponent extends Vue {
    public user?: ExtendedUserPermissions = null;
    public userPermissions: string[] = [];

    async created(): Promise<void> {
        await this.loadPermissions();
    }

    async loadPermissions(): Promise<void> {
        this.user = await User.getUserData();
        this.userPermissions = await User.getPerm();
    }

    private get applications(): Application[] {
        return Data.Instance.coodeApplications;
    }

    openQueryHub(): void {
        const env = process.env.VUE_APP_ENVIRONMENT ?? 'dev';
        const queryHubUseCaseId = QUERY_HUB_USE_CASE_IDS[env];

        const queryHubApp = this.applications.find(
            (app) => String(app.id) === String(queryHubUseCaseId)
        );

        if (!queryHubApp?.url) return;

        const currentApp = this.applications.find(
            (app) => String(app.id) === String(process.env.VUE_APP_USE_CASE_ID)
        );

        const fallback = 'I have a problem with';
        const problemMessage = String((this as any).$t('queryHub.redirect.problemMessage') || fallback);
        const prompt = `${problemMessage} ${currentApp?.name ?? 'PML'}`;

        window.open(`${queryHubApp.url}?prompt=${encodeURIComponent(prompt)}`, '_blank');
    }

    sendToFeedbackForm(): void {
        const useCaseId = Number(process.env.VUE_APP_USE_CASE_ID ?? 0);
        const appStoreUrl = `${process.env.VUE_APP_EXTERNAL_APP_APPSTORE_URL}/contact-page/${useCaseId}?isFeedback=true`;

        window.open(appStoreUrl, '_blank');
    }

    sendToIncidentReporting(): void {
        const useCaseId = Number(process.env.VUE_APP_USE_CASE_ID ?? 0);
        const appStoreUrl = `${process.env.VUE_APP_EXTERNAL_APP_APPSTORE_URL}/incident-page/${useCaseId}`;

        window.open(appStoreUrl, '_blank');
    }

    async logout(): Promise<void> {
        await User.signOut();
    }
}
